<template>
  <div>
    <v-dialog
      v-model="dialog"
      eager
      scrollable
      max-width="650px"
      content-class="rounded-dialog"
    >
      <v-form ref="MyDesignationFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    {{ action }} Designationwdwadawd
                  </div>

                  <div class="dialog-subtitle">
                    Fill in the required information below
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-autocomplete
                    outlined
                    v-model="assigned_office"
                    :rules="[formRules.required]"
                    readonly
                    class="rounded-lg"
                    label="Assigned Office"
                    color="#6DB249"
                    item-text="name"
                    item-value="id"
                    :items="officeList"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-autocomplete
                    readonly
                    outlined
                    v-model="designationID"
                    :rules="[formRules.required]"
                    item-text="description"
                    item-value="id"
                    :items="designationList"
                    class="rounded-lg"
                    label="Designation"
                    color="#6DB249"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-text-field
                    readonly
                    outlined
                    v-model="units"
                    :rules="[formRules.zeroAllowed]"
                    required
                    label="Units Deload"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-text-field
                    readonly
                    outlined
                    v-model="specialOrderNo"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    label="Special Order"
                    color="#6DB249"
                  >
                  </v-text-field>
                </v-col>

                <v-col v-if="status == 2 && !fileName">
                  <div>no file uploaded</div>
                </v-col>

                <v-col cols="12" v-else>
                  <v-file-input
                    v-if="showFileUpload"
                    clearable
                    outlined
                    dense
                    label="Upload Special Order File"
                    accept=".pdf"
                    class="rounded-lg"
                    v-model="sp_file"
                  ></v-file-input>

                  <div class="d-flex align-center">
                    <v-btn
                      small
                      v-if="!showFileUpload"
                      color="warning"
                      class="white--text ml-2"
                      @click="downloadFile()"
                    >
                      <v-icon>mdi-download</v-icon>
                      Download File
                    </v-btn>
                    <div
                      v-if="!showFileUpload"
                      class="ml-2 text-truncate"
                      style="max-width: 300px"
                    >
                      {{ fileName }}
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-menu
                    ref="effectivityDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="effectivityDate"
                    transition="scale-transition"
                    offset-y
                    readonly
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        v-model="effectivityDate"
                        :rules="[formRules.required]"
                        chips
                        small-chips
                        label="Effectivity Date"
                        color="#6DB249"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      readonly
                      color="#6DB249"
                      v-model="effectivityDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="$refs.effectivityDateMenu.save(effectivityDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" class="pa-0 pt-2 px-4">
                  <v-select
                    outlined
                    :rules="[formRules.required]"
                    :items="statusList"
                    label="Status"
                    color="#93CB5B"
                    v-model="isActive"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>
            <v-btn class="btn-save" v-if="action == 'Add'" @click="addnew()">
              Add
            </v-btn>
            <v-btn class="btn-save" v-if="action == 'Update'" @click="update()">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    action: null,
  },
  data() {
    return {
      id: null,
      dialog: false,
      empID: null,
      designationID: null,
      units: null,
      effectivityDate: null,
      specialOrderNo: null,
      assigned_office: null,

      schoolYearFrom: null,
      schoolYearTo: null,
      sem: null,
      isActive: null,

      statusList: ["Active", "Inactive"],
      semList: [
        { id: 1, title: "First Semester" },
        { id: 2, title: "Second Semester" },
        { id: 3, title: "Summer" },
      ],

      tapTimeList: [
        { id: 1, title: "First Part" },
        { id: 2, title: "Second Part" },
        { id: 3, title: "Overtime" },
      ],
      tapTimePartID: null,
      designationList: [],
      officeList: [],

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      sp_file: null,
      fileName: null,
      status: null,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        if (data.id) {
          this.initialize();
          this.id = data.id;
          this.designationID = parseInt(data.designationID);
          this.getEmpDetails();
          this.units = data.units == 0 ? "0" : data.units;
          this.effectivityDate = data.effectivityDate;
          this.specialOrderNo = data.specialOrderNo;
          this.assigned_office = data.assigned_office;
          this.isActive = data.isActive ? "Active" : "Inactive";
          this.fileName = data.filename;
          this.status = data.status;
        } else {
          this.initialize();
          this.getEmpDetails();
          this.units = 0;
          this.empID = data.empID;
          this.effectivityDate = null;
          this.specialOrderNo = null;
          this.designationID = null;
          this.sem = null;
          this.isActive = null;
          this.fileName = null;
          this.status = null;
        }
      },
      deep: true,
    },
  },

  computed: {
    showFileUpload() {
      if (this.action == "Add") {
        return true;
      } else {
        if (!this.fileName) {
          return true;
        } else {
          return false;
        }
      }
    },
  },

  methods: {
    initialize() {
      this.getOffices();
      this.getDesignations();
    },

    update() {
      if (this.$refs.MyDesignationFormref.validate()) {
        let data = {
          designationID: this.designationID,
          effectivityDate: this.effectivityDate,
          specialOrderNo: this.specialOrderNo,
          assigned_office: this.assigned_office,
          units: this.units,
          isActive: this.isActive == "Active" ? true : false,
        };

        this.axiosCall(
          "/my-designation/updateByHR/" + this.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.$refs.MyDesignationFormref.reset();
            this.closeD();
          } else if (res.data.status == 400) {
            this.dialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.assigned_office = res.data.officeID;
      });
    },
    closeD() {
      this.eventHub.$emit("closeEmployeeDesignationDetailsDialog", false);
      this.dialog = false;
    },
    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },

    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },

    downloadFile() {
      let url =
        process.env.VUE_APP_SERVER + "/my-designation/getFile/" + this.fileName;

      let token = localStorage.getItem("token");

      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.fileName);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
